module.exports = __webpack_public_path__ + "img/later2x.172337b0.png";